export const ROOT = 'root';
export const ITEM = 'item';
export const GROUP = 'group';

export default function getNodeType(competencyTree, itemId) {
  if (competencyTree.isCompetencyDocument(itemId)) {
    return ROOT;
  }

  if (competencyTree.itemsWithoutParents.includes(itemId)) {
    return GROUP;
  }

  return ITEM;
}
